// extracted by mini-css-extract-plugin
module.exports = {"content":"_2SCTXs","copyright":"_3wBdwC","footer":"_1dGXbN","right":"-cXoUX"};